import React from 'react'

import AvailabilityStore from '../stores/AvailabilityStore.js'
import AvailabilityActions from '../actions/AvailabilityActions.js'

import { translate } from 'react-i18next';

var ServiceAvailable = React.createClass({


  getInitialState() {
    return {store: AvailabilityStore.getState()};
  },

  componentDidMount() {
    AvailabilityStore.listen(this.onChange);
  },

  componentWillUnmount() {
    AvailabilityStore.unlisten(this.onChange);
  },

  onChange(state) {
    this.setState({store: state});
  },

  backToStepOne() {
    AvailabilityActions.backToStepOne();
  },

  notMyAddr() {
    AvailabilityActions.notMyAddr();
  },

	render() {
      const { t } = this.props;
      var store = this.state.store;

    var qa = store.get('qualified_address').toJS();
    var postal = store.get('postal_address').toJS();

    if(qa.unit) {
      qa.address = qa.address + ', ' + qa.unit;
    } else if (qa.LocationValue1){
      qa.address = (qa.LocationDesignator1 ? qa.address + ', ' + qa.LocationDesignator1 + ' '+ qa.LocationValue1 : qa.address + ', ' + qa.LocationValue1);
    }

    var mapImage = '';
    var w = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    var mapAddr = qa.address.replace(/ /g, '+') + '+' + qa.zip;
    var sizingString = "&zoom=12&size=768x100&markers=size:tiny";

    if(w >= 768) {
      sizingString = "&zoom=15&size=768x200&markers=size:mid";
    }

    /*
    // JIRA SP-83 google map displays user's input address not qualified address
    if(store.get('verified_address').size) {
      var latitude = store.getIn(['verified_address', 'metadata', 'latitude']);
      var longitude = store.getIn(['verified_address', 'metadata', 'longitude']);

      mapImage = {
          backgroundImage: "url(https://maps.googleapis.com/maps/api/staticmap?center="+latitude+","+longitude+"&maptype=roadmap&scale=2"+sizingString+"|color:0x26abe2|"+latitude+","+longitude+"&sensor=false)"
      };
    }
    else {
    */
      mapImage = {
          backgroundImage: "url(https://maps.googleapis.com/maps/api/staticmap?center="+mapAddr+"&maptype=roadmap&scale=2"+sizingString+"|color:0x26abe2|"+mapAddr+"&sensor=false&key="+GOOGLEAPIKEY+")" 
      };      
    //}

    var co_distance, prequal_key, qual_issue;
    if(store.get('sso_user')) {
      prequal_key = <span>Prequal Key: {store.get('async_id')}</span>
      qual_issue = <div style={{width:'150px',margin:'auto'}}><a className="snc-btn snc-btn--sm" href={'https://sontec.sontrak.net/sontec-ng/ticket/create/qual/?prequal_key=' + store.get('async_id')} target="_blank">Qual Issue</a></div>
    }
    if(store.get('fusion_available')) {
      co_distance = <div><small>{t('common:co_distance')} {store.getIn(['lastPrequal', 'response', 'loop_distance'])}ft {prequal_key}<br/></small>{qual_issue}</div>;
    }
    else {
      co_distance = prequal_key;
    }


    var address = {
      address: store.getIn(['input_address', 'streetAddress']),
      unit: store.getIn(['input_address', 'secondary']),
      city: store.getIn(['input_address', 'city']),
      human_city: store.getIn(['input_address', 'human_city']),
      state: store.getIn(['input_address', 'state']),
      zip: store.getIn(['input_address', 'zip']),
      serviceType: store.getIn(['input_address', 'serviceType'])
    }

    address.human_city ? address.human_city: address.city;

    if(address.unit) {
      address.address = address.address + ' ' + address.unit;
    }

    var products_includes_ftth_self_install = !!store.get('products').toJS().filter(function(a) { return typeof a.should_offer_self_install !== 'undefined' && a.should_offer_self_install === 1 }).length ;

    return (


        <div className="text-center service-available" key="serviceAvailable">
          <div className="prequal-input-display">
            {t('common:you_entered')} 
            <span className="text-nowrap"> <span className="address-only">{address.address}, {address.human_city} {address.state} {address.zip}</span>, {t('common:for_'+address.serviceType)}</span> 
            <a className="btn btn-sm" onClick={this.backToStepOne}> {t('common:go_back_to_form')}</a>
          </div>

          <div className="map" style={mapImage}>
            <img src="https://www.google.com/images/branding/mapslogo/1x/googlelogo_62x24_with_2_stroke_color_66x26dp.png" />
          </div>

          <div className="map-after">
            <div className="foo">
              <a className="btn btn-circle btn-success btn-lg">
                <i className="fa fa-check"></i>
              </a>

                {(products_includes_ftth_self_install === true
                  ? <h2 className="ftth_self_install__header">
                      <span className="ftth_self_install__phrase">Great news!</span>
                      <span className="ftth_self_install__phrase ftth_self_install__phrase--strong">Your address is already wired for Sonic Gigabit Fiber.</span>
                      <span className="ftth_self_install__phrase">Get activated in minutes!</span>
                    </h2>
                  : <h2>{t('common:sonic_is_available')}</h2>
                )}
            </div>

                <p className="lead">
              <span>{t('common:we_found_addr')} </span> 
              <strong >
                <span className="address-only">
                  {qa.address}, {postal.city ? postal.city : qa.city}, {qa.state} {qa.zip} 
                </span>
              </strong>  
              <br />
                {co_distance}
                <small className="not_your_addr"> 
                  (<a className="btn btn-sm" onClick={this.notMyAddr}>{t('common:not_your_addr')}</a>)
                </small>
              </p>
            </div>

        </div>

    );
  }
});

export default  translate('common', { wait: true })(ServiceAvailable);